import { DEFAULT_NOTIFICATION_PREFERENCES } from '../constants'

export const initialNotificationPreferencesState = {
  notificationPreferences: { ...DEFAULT_NOTIFICATION_PREFERENCES },
}
